import React from 'react';
import { setClasseForm } from '../../../../../store/actions';
import FormCreateClasse from './FormCreateClasse';
import { MESSAGES } from '../../../../../helpers/messages';
import {
  maxClasseDateChallenge,
  minClasseDateChallenge
} from '../../../../../types/classe/classe.def';
import { ButtonWithText } from '../../../../atoms/Buttons/ButtonWithText';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../../store/reducers';
import { classeFormErrorHandling } from '../../../../../helpers/forms/formsErrorHandling/classeFormErrorHandling';

export interface CreateClasseTypes {
  step: number;
  setStep: (step) => void;
}

const CreateClasse = ({ step, setStep }: CreateClasseTypes) => {
  const classe = useSelector((state: AppState) => state.createClasse);
  const dispatch = useDispatch();
  const handleChange = e => {
    if (e.target.name === 'fin' && e.target.value > maxClasseDateChallenge)
      return toast.error(MESSAGES.error.createClasse.dateMax);
    dispatch(
      setClasseForm(
        classeFormErrorHandling(classe, e.target.name, e.target.value)
      )
    );

    if (e.target.name === 'debut' && e.target.value < minClasseDateChallenge)
      return toast.error(MESSAGES.error.createClasse.dateMin);
    dispatch(
      setClasseForm(
        classeFormErrorHandling(classe, e.target.name, e.target.value)
      )
    );
  };
  return (
    <>
      <FormCreateClasse handleChange={handleChange} classe={classe} />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <ButtonWithText
          content={'Précédent'}
          onClick={() => setStep(step - 1)}
          icon={'LeftArrow'}
          iconColor={'white'}
          variant={'primaryBlue'}
          iconPosition={'start'}
        />
        <ButtonWithText
          content={'Suivant'}
          onClick={() => setStep(step + 1)}
          icon={'RightArrow'}
          iconColor={'white'}
          variant={'primaryBlue'}
          disabled={!classe.isValid}
        />
      </div>
    </>
  );
};

export default CreateClasse;
